import { Star, Quote } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { TESTIMONIALS } from "@/data/content";

export default function Testimonials() {
  return (
    <section data-testid="testimonials" className="bg-white py-24 lg:py-32 border-y border-brand-ink/10">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand-brown mb-4">Testimonials</p>
          <h2 className="font-heading font-bold text-brand-ink tracking-tight text-3xl sm:text-5xl max-w-2xl leading-[1.05]">
            Trusted across farms & fields.
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.08}>
              <figure data-testid={`testimonial-${i}`} className="h-full flex flex-col rounded-2xl bg-brand-cream border border-brand-ink/10 p-8 hover:border-brand-green/40 transition-colors">
                <Quote className="size-8 text-brand-green/30" />
                <div className="flex gap-0.5 mt-5">
                  {Array.from({ length: t.rating }).map((_, k) => (
                    <Star key={k} className="size-4 fill-brand-brown text-brand-brown" />
                  ))}
                </div>
                <blockquote className="mt-4 flex-1 text-brand-ink/80 leading-relaxed">“{t.quote}”</blockquote>
                <figcaption className="mt-6 pt-5 border-t border-brand-ink/10">
                  <div className="font-heading font-bold text-brand-ink">{t.name}</div>
                  <div className="text-sm text-brand-ink/55">{t.role}</div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
